export enum HawkerSessionForm {
  SessionId = 'y5rF',
  SessionStatus = 'MOCL',
  NoAvailableCommissarySite = 'Vk7m',
  SelectSite = 'S+Cf',
  SessionsBrackets = 'BY2x',
  AddProducts = 'DXtd',
  AddProduct = 'Hver',
  AddToRequestList = 'd6SL',
  NoAvailableCommissionRate = '7+9t',
  RequestList = '6GXB',
  LoadRequested = 'Qkzp',
  QtyReturned = 'F0rr',
  TotalQtyRequested = 'A3xF',
  TotalQtyReturned = 'SQ/T',
  CancelSession = 'Xp3k',
  Session = 'Pzrx',
  SessionsBracketsLowerCase = 'qeub',
  SaveHawkerSessionChanges = '2Mph',
  NetQtyTaken = 'wAD5',
  TotalQtyDifference = 'Ogx2',

  HawkerHasAnotherOpenSession = 'i67d',
  CloseOut = 'AwHn',
  ConfirmToCloseOut = 'aJ5b',
  CloseOutReview = 'hlBu',
  Commissions = '+qB1',
  VarianceQtyTipForHawkerSession = 'e99Y',
  TerminalSalesTipForHawkerSession = 'DjpD',
  TerminalSalesTotalTip = 'Gjgs',
  TaxesTotalTip = 'z8J1',
}
